import React, { useState } from "react";
import Slider from "react-slick";
import { certificate1, certificate2, certificate3 } from "../../assets/index";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { MdArrowForwardIos, MdArrowBackIos } from "react-icons/md";

const Certificates = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    beforeChange: (current, next) => setCurrentSlide(next),
    appendDots: (dots) => <ul className="mt-10">{dots}</ul>,
    customPaging: (i) => (
      <div
        className={`w-2 h-2 md:w-3 md:h-3 mt-8 rounded-full cursor-pointer ${
          i === currentSlide ? "bg-designColor" : "bg-gray-400"
        }`}
      ></div>
    ),
  };

  return (
    <section
      id="certificates"
      className="w-full h-full py-10 flex flex-col items-center border-b-[1px] border-b-black font-titleFont gap-16 pb-20"
    >
      <h2 className="text-3xl lg:text-4xl w-full flex justify-center text-black xl:pt-4">
        Certificates
      </h2>
      <div className=" w-full h-full xl:w-[60%] xl:h-[60%] shadow-custom">
        <Slider {...settings}>
          <div>
            <img
              src={certificate1}
              alt="Certificate 1"
              className="w-full h-full object-contain"
            />
          </div>
          <div>
            <img
              src={certificate2}
              alt="Certificate 2"
              className="w-full h-full object-fill"
            />
          </div>
          <div>
            <img
              src={certificate3}
              alt="Certificate 3"
              className="w-full h-full object-contain"
            />
          </div>
        </Slider>
      </div>
    </section>
  );
};

function SampleNextArrow(props) {
  const { onClick } = props;
  return (
    <div
      className="absolute top-1/2 right-2 transform -translate-y-1/2 bg-transparent text-gray-400 hover:text-designColor text-3xl hover:text-4xl p-2 cursor-pointer z-10 transition-all duration-300 hidden md:block"
      onClick={onClick}
    >
      <MdArrowForwardIos />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { onClick } = props;
  return (
    <div
      className="absolute top-1/2 left-2 transform -translate-y-1/2 bg-transparent text-gray-400 hover:text-designColor text-3xl hover:text-4xl p-2 cursor-pointer z-10 transition-all duration-300 hidden md:block"
      onClick={onClick}
    >
      <MdArrowBackIos />
    </div>
  );
}

export default Certificates;
